import { Page, PageProps } from '@encompaas/common/components';
import logo from '@encompaas/common/assets/images/encompaasLogoBackground.png';

export const AppPage = ({ children, ...props }: PageProps) => (
  <Page {...props}>
    {children}
    <img alt='logo' src={logo} className='apps-page-background-image' />
  </Page>
);
